import {
  FETCH_STUDENT_RESULTS_LAST_MONTH_BEGIN,
  FETCH_STUDENT_RESULTS_LAST_MONTH_FULFILLED,
  FETCH_STUDENT_RESULTS_LAST_MONTH_REJECTED,
  FETCH_STUDENT_RESULTS_BY_STUDENT_BEGIN,
  FETCH_STUDENT_RESULTS_BY_STUDENT_FULFILLED,
  FETCH_STUDENT_RESULTS_BY_STUDENT_REJECTED,
  FETCH_STUDENT_AVERAGE_RESULTS_BY_STUDENT_BEGIN,
  FETCH_STUDENT_AVERAGE_RESULTS_BY_STUDENT_FULFILLED,
  FETCH_STUDENT_AVERAGE_RESULTS_BY_STUDENT_REJECTED,
  FETCH_STUDENT_RESULTS_TIMELINE_BY_STUDENT_BEGIN,
  FETCH_STUDENT_RESULTS_TIMELINE_BY_STUDENT_FULFILLED,
  FETCH_STUDENT_RESULTS_TIMELINE_BY_STUDENT_REJECTED
} from "../actions/studentResultsActions";

const initialStateStudentResults = {
  loading: true,
  error: null,
  result: [
    {
      id: null,
      student: {
        id: 1,
        name: null,
        email: null,
        classes: [
          {
            classId: 0,
            className: null,
            schoolId: 0,
            schoolName: null,
            active: false
          }
        ]
      },
      licenses: [
        {
          courses: [],
          programLicenses: []
        }
      ],

      status: null,
      score: 0,
      activityPoints: 0,
      lastRun: null,
      courseName: null,
      courseId: 0,
      module: null,
      moduleId: 0,
      maxScore: 0,
      approveLimit: 0,
      maxActivityPoints: 0,
      isFinalExam: false,
      studentIsDone: false,
      studentHasPassed: false
    }
  ],
  statusCode: null
};

export function studentResultsReducer(
  state = initialStateStudentResults,
  action
) {
  switch (action.type) {
    case "FETCH_STUDENT_RESULTS_BEGIN": {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case "FETCH_STUDENT_RESULTS_SUCCESS": {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    case "FETCH_STUDENT_RESULTS_FAILURE": {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        result: []
      };
    }
    default:
      return state;
  }
}

const INIT_STUDENTRUN_LAST_MONTH = {
  error: null,
  loading: false,
  result: [],
  statusCode: null
};

export function studentRunReducer(
  state = INIT_STUDENTRUN_LAST_MONTH,
  action = {}
) {
  switch (action.type) {
    case FETCH_STUDENT_RESULTS_LAST_MONTH_BEGIN: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case FETCH_STUDENT_RESULTS_LAST_MONTH_FULFILLED: {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    case FETCH_STUDENT_RESULTS_LAST_MONTH_REJECTED: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        result: []
      };
    }

    default: {
      return { ...state };
    }
  }
}

const INIT_STUDENT_RESULT_BY_STUDENT = {
  error: null,
  loading: false,
  result: [],
  statusCode: null
};

export function studentResultByStudentReducer(
  state = INIT_STUDENT_RESULT_BY_STUDENT,
  action = {}
) {
  switch (action.type) {
    case FETCH_STUDENT_RESULTS_BY_STUDENT_BEGIN: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case FETCH_STUDENT_RESULTS_BY_STUDENT_FULFILLED: {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    case FETCH_STUDENT_RESULTS_BY_STUDENT_REJECTED: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        result: []
      };
    }

    default: {
      return { ...state };
    }
  }
}

const INIT_STUDENT_AVERAGE_RESULT_BY_STUDENT = {
  error: null,
  loading: false,
  result: [],
  statusCode: null
};

export function studentAverageResultByStudentReducer(
  state = INIT_STUDENT_AVERAGE_RESULT_BY_STUDENT,
  action = {}
) {
  switch (action.type) {
    case FETCH_STUDENT_AVERAGE_RESULTS_BY_STUDENT_BEGIN: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case FETCH_STUDENT_AVERAGE_RESULTS_BY_STUDENT_FULFILLED: {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    case FETCH_STUDENT_AVERAGE_RESULTS_BY_STUDENT_REJECTED: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        result: []
      };
    }

    default: {
      return { ...state };
    }
  }
}

const INIT_STUDENT_RESULT_TIMELINE = {
  error: null,
  loading: false,
  result: [],
  statusCode: null
};

export function studentResultTimelineReducer(
  state = INIT_STUDENT_RESULT_TIMELINE,
  action = {}
) {
  switch (action.type) {
    case FETCH_STUDENT_RESULTS_TIMELINE_BY_STUDENT_BEGIN: {
      return {
        ...state,
        loading: true,
        error: null
      };
    }
    case FETCH_STUDENT_RESULTS_TIMELINE_BY_STUDENT_FULFILLED: {
      return {
        ...state,
        loading: false,
        result: action.payload
      };
    }
    case FETCH_STUDENT_RESULTS_TIMELINE_BY_STUDENT_REJECTED: {
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        result: []
      };
    }

    default: {
      return { ...state };
    }
  }
}
